import { Skeleton } from "@volca/ui/components/ui/skeleton";
import { Stack } from "@volca/ui/components/ui/stack";
import { Tabs, TabsList, TabsTrigger } from "@volca/ui/components/ui/tabs";
import { BusinessSettingsSidebarHeaderSkeleton } from "@/business-settings/common/business-settings-sidebar-header-skeleton";
import { BusinessSettingsSidebarWrapper } from "@/business-settings/common/business-settings-sidebar-wrapper";

export const LeadSidebarSkeleton = () => (
  <BusinessSettingsSidebarWrapper>
    <BusinessSettingsSidebarHeaderSkeleton />
    <div className="flex-1 overflow-hidden">
      <Stack align="start" gap={0} className="h-full w-full">
        <Tabs className="flex w-full flex-1 flex-col gap-0 overflow-hidden px-6">
          <div className="border-b">
            <TabsList variant="line" className="w-full justify-center">
              <TabsTrigger value="details">
                <Skeleton className="h-2 w-10"></Skeleton>
              </TabsTrigger>
              <TabsTrigger value="notes">
                <Skeleton className="h-2 w-10"></Skeleton>
              </TabsTrigger>
            </TabsList>
          </div>

          <Stack align="start" gap={4} className="w-full pt-4">
            <Stack className="w-full" align="start" gap={6}>
              <Skeleton className="h-14 w-full"></Skeleton>
              <Stack className="w-full" align="start" gap={1}>
                <Skeleton className="h-14 w-full"></Skeleton>
                <Skeleton className="h-8 w-full"></Skeleton>
              </Stack>

              <Stack className="w-full" align="start" gap={1}>
                <Skeleton className="h-4 w-16"></Skeleton>
                <Skeleton className="h-5 w-20"></Skeleton>
              </Stack>

              <Stack align="start" direction="row" gap={4}>
                <Skeleton className="h-10 w-39"></Skeleton>
                <Skeleton className="h-10 w-26"></Skeleton>
              </Stack>
            </Stack>
          </Stack>
        </Tabs>
      </Stack>
    </div>
  </BusinessSettingsSidebarWrapper>
);
